import React from "react";
import {Modal} from "antd";
import {ExclamationCircleOutlined} from '@ant-design/icons';
import {useSelector} from "react-redux";
import {TUserInfoTypes} from "@/types/redux_type";

type TUnRealNameWarningModal = React.FC & {
  showModal:() => void;
}

const UnRealNameWarningModal:TUnRealNameWarningModal = ({children}) => {
  const userInfo = useSelector<{ userInfo: TUserInfoTypes },TUserInfoTypes>(state => state.userInfo);
  return (
    <>
      <div onClick={(e) => {
        console.log(userInfo.isPassRealnameAuthentication)
        if (!userInfo.isPassRealnameAuthentication){
          e.stopPropagation();
          Modal.confirm({
            icon: <ExclamationCircleOutlined />,
            title:"请先进行实名认证",
            content: "认证考试仅对实名用户开放，认证后方可参加考试",
            okText:"立即认证",
            onOk() {
              window.location.href=`${process.env.NEXT_PUBLIC_PASSPORT_URL}#/info/auth/realname?srcURL=${window.location.href}`;
            },
          });
        }
      }}>{children}</div>
    </>
  )
}
UnRealNameWarningModal.showModal = () => {
  Modal.warning({
    icon: <ExclamationCircleOutlined />,
    title:"请先进行实名认证",
    content: "认证考试仅对实名用户开放，认证后方可参加考试",
    okText:"立即认证",
    onOk() {
      window.location.href=`${process.env.NEXT_PUBLIC_PASSPORT_URL}#/info/auth/realname?srcURL=${window.location.href}`;
    },
  });
}
export default UnRealNameWarningModal;
